import styled from "styled-components";
import { colors } from "../../common/ui/globalColors";

export const StyledAutoCampaign = styled.div`
    .page-title {
        font-size: 26px;
        line-height: 30px;
    }

    .tabs {
        display: flex;
        justify-content: flex-start;
        padding: 30px 0 36px;
    }
`

export const StyledAutoCampaignList = styled.div`
    border: 1px solid rgba(110, 116, 255, 0.4);
    border-radius: 28px;
    padding: 27px 24px;
    position: relative;

    .ScrollbarsCustom-Content {
        padding-right: 24px !important;

      .select-method-radio{
        display: grid;
        gap:10px;
      }
        .list-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 15px;
            border-bottom: 1px solid rgba(110, 116, 255, 0.4);
            direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
    
            .total-apartments {
                font-weight: 700;
                font-size: 17px;
                line-height: 25px;            
                color: rgba(55, 54, 71, 0.7);
    
                span {
                    font-weight: 400;
                }
            }
        }
    
        .cards-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-top: 19px;

          .titles {
            direction: ${({ltr}) => ltr ? 'ltr' : 'rtl'};
            display: flex;
            .cards-titles {
              display: grid;
              grid-template-columns: ${({inMonitoring}) => inMonitoring ? 'repeat(8, 1fr)' : 'repeat(6, 1fr)'};
              font-weight: 700;
              font-size: 14px;
              line-height: 25px;
              text-align: center;
              color: rgba(55, 54, 71, 0.7);
              padding: 0 20px;
              padding-inline-start: 32px;
              direction: inherit;
              width: 100%;
            }
          }
          .list-rows{
            display: grid;
            gap: 15px;
          }
        }
    }


    .selected-items-pop-up {
        position: sticky;
        width: fit-content;
        bottom: 22px;
        right: 55px;
        background: #FFFFFF;
        box-shadow: 0px 5px 30px rgba(89, 102, 137, 0.3);
        border-radius: 11px;
        padding: 12px 22px;
        display: flex;
        align-items: center;

        .items-selected {
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            text-align: center;
            color: ${colors.textColors.blue};
            width: auto;

            .quantity {
                font-size: 17px;
                line-height: 22px;
                margin-bottom: 3px;
            }
        }

        .add-or-remove {
            display: flex;
            flex-direction: column;
            gap: 4px;
            align-items: center;
            font-size: 14px;
            line-height: 16px;
            color: rgba(55, 54, 71, 0.7);
            text-align: center;
            border-right: 1px solid rgba(110, 116, 255, 0.4);
            border-left: 1px solid rgba(110, 116, 255, 0.4);
            padding: 0 49px;
            margin-inline-end: 16px;
            margin-inline-start: 18px;
            cursor: pointer;

          div {
                width: 85px;
            }
        }

        .close-items-pop-up {
            width: 30px;
            height: 30px;
            cursor: pointer;
        }
    }
`

export const StyledAutoCampaignCard = styled.div`
    display: flex;
    width: 100%;
    gap: 10px;
    direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};

    .card {
        width: 100%;
        background: rgba(255, 255, 255, 0.5);
        border: 1px solid ${colors.additionalColors.lightBlue};
        box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
        border-radius: 11px;
        padding: 8px 20px;
        display: grid;
        grid-template-columns: ${({ inMonitoring }) => inMonitoring ? 'repeat(8, 1fr)' : 'repeat(6, 1fr)'};
        text-align: center;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        color: rgba(55, 54, 71, 0.7);
    
        .apt-notes {
            cursor: pointer;
        }
      .apt-content{
        display: grid;
        gap: 5px;
      }
    }
`